
export default {
  'filters.title': 'Filtros',
  'filters.browse': 'Filtros',
  'filters.saved': 'Filtros guardados',
  'filters.basic': 'Básico',
  'filters.attributes': 'Atributos',
  'filters.availability': 'Disponibilidad',
  'filters.location': 'Ubicación',
  'filters.age_range': 'Rango de edad',
  'filters.gender': 'Género',
  'filters.services': 'Servicios',
  'filters.languages': 'Idiomas',
  'filters.verification': 'Estado de verificación',
  'filters.status': 'Estado',
  'filters.price_range': 'Rango de precios',
  'filters.all_locations': 'Todas las ubicaciones',
  'filters.search_location': 'Buscar ubicación...',
  'filters.no_location_found': 'No se encontró ubicación',
  'filters.reset': 'Reiniciar filtros',
  'filters.apply': 'Aplicar filtros',
  'filters.save': 'Guardar filtro',
  'filters.filter_name': 'Nombre del filtro',
  'filters.save_current_filter': 'Guardar filtro actual',
  'filters.delete': 'Eliminar',
  'filters.no_saved_filters': 'Aún no hay filtros guardados',
  'filters.select_filter': 'Seleccionar un filtro',
  'filters.applied_filters': 'Filtros aplicados:',
  
  // Sort filter options
  'filters.sort_by': 'Ordenar por',
  'filters.sort_options.newest': 'Más reciente',
  'filters.sort_options.popularity': 'Más popular',
  'filters.sort_options.relevance': 'Más relevante',
  'filters.show_with_reviews': 'Mostrar perfiles con reseñas',
  
  // Advanced filters
  'filters.physical_attributes': 'Atributos físicos',
  'filters.height': 'Altura',
  'filters.weight': 'Peso',
  'filters.hair_color': 'Color de pelo',
  'filters.eye_color': 'Color de ojos',
  'filters.body_type': 'Tipo de cuerpo',
  'filters.habits': 'Hábitos',
  'filters.smoking': 'Fumar',
  'filters.drinking': 'Beber',
  'filters.available_days': 'Días disponibles',
  'filters.available_hours': 'Horas disponibles',
  'filters.from': 'De',
  'filters.to': 'A',
  'filters.select_hour': 'Seleccionar hora',
  'filters.select_all': 'Seleccionar todo',
  'filters.clear': 'Borrar',
  
  'filters.options.yes': 'Sí',
  'filters.options.no': 'No',
  'filters.options.occasionally': 'Ocasionalmente',
  
  'filters.hair_colors.blonde': 'Rubio',
  'filters.hair_colors.brown': 'Castaño',
  'filters.hair_colors.black': 'Negro',
  'filters.hair_colors.red': 'Pelirrojo',
  'filters.hair_colors.other': 'Otro',
  
  'filters.eye_colors.blue': 'Azul',
  'filters.eye_colors.green': 'Verde',
  'filters.eye_colors.brown': 'Marrón',
  'filters.eye_colors.hazel': 'Avellana',
  'filters.eye_colors.other': 'Otro',
  
  'filters.body_types.slim': 'Delgado',
  'filters.body_types.athletic': 'Atlético',
  'filters.body_types.average': 'Medio',
  'filters.body_types.curvy': 'Curvilíneo',
  'filters.body_types.plus_size': 'Talla grande',
  
  'filters.days.monday': 'Lunes',
  'filters.days.tuesday': 'Martes',
  'filters.days.wednesday': 'Miércoles',
  'filters.days.thursday': 'Jueves',
  'filters.days.friday': 'Viernes',
  'filters.days.saturday': 'Sábado',
  'filters.days.sunday': 'Domingo',
};
